import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog';
import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog';
import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
import PanelistSurveyVoteEditorDr from "@Evaluation/AlternativesSurveys/Components/PanelistSurveyVoteEditorDr.vue";
import PanelistSurveyVoteEditorPc from "@Evaluation/AlternativesSurveys/Components/PanelistSurveyVoteEditorPc.vue";
import { SavePanelistVotesCommandV1 } from "@Evaluation/AlternativesSurveys/Domain/commands-core";
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { PanelistSurveyAlternativePageReadModel, PanelistSurveyQuestionReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { isNullOrWhitespace } from "@common/Common";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PanelistSurveyVoteEditorDr, PanelistSurveyVoteEditorPc, AlternativeDetailsDialog, CriterionDetailsDialog
    },
    watch: {
        IsSaved: 'onIsSavedChanged'
    }
})
export default class PanelistSurveyAlternativePage extends mixins(ScoringCommands, ScoringQueries) {

    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get surveyId(): number { return Number(this.$route?.params?.surveyId ?? 0); }
    get projectUserId(): number { return Number(this.$route?.params?.projectUserId ?? 0); }
    get alternativeId(): string { return this.$route?.params?.alternativeId ?? ''; }

    initialized: boolean = false;
    IsSaved: boolean = true;
    AutoSaveHandle: NodeJS.Timeout = null;
    SearchPhrase: string = null;
    QuestionsFilter: string = null;
    alternativeDetailsDialog = new AlternativeDetailsDialogViewModel();
    criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();

    rm: PanelistSurveyAlternativePageReadModel = null;
    get alternativeLabel(): string { return this.rm.AlternativeLabel; }
    get alternativesLabel(): string { return this.rm.AlternativesLabel; }
    get alternativeName(): string { return this.rm.AlternativeName; }
    get alternativeDescription(): string { return this.rm.AlternativeDescription; }
    get nextAlternativeId(): string { return this.rm.NextAlternativeId; }
    get prevAlternativeId(): string { return this.rm.PrevAlternativeId; }
    get questionsCount(): number { return this.rm.Questions.length; }
    get directRates(): PanelistSurveyQuestionReadModel[] { return this.rm.Questions.filter(a => a.IsPairwise === false); }
    get pairwiseComparisons(): PanelistSurveyQuestionReadModel[] { return this.rm.Questions.filter(a => a.IsPairwise === true); }
    get progress(): number { return Math.round(100 * this.AnsweredQuestionsCount / this.questionsCount); }

    get DirectRatesView()
    {
        let view = [...this.directRates];

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(q => q.CriterionPath.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.QuestionsFilter === "Answered")
        {
            view = view.filter(a => a.Value != null);
        }
        else if (this.QuestionsFilter === "Not answered")
        {
            view = view.filter(a => a.Value == null);
        }
        else if (this.QuestionsFilter === "Commented")
        {
            view = view.filter(a => !isNullOrWhitespace(a.Comment));
        }
        else if (this.QuestionsFilter === "Not commented")
        {
            view = view.filter(a => isNullOrWhitespace(a.Comment));
        }

        return view;
    }
    get PairwiseComparisonsView()
    {
        let view = [...this.pairwiseComparisons];

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(q => q.CriterionPath.toLowerCase().indexOf(phrase) >= 0 || q.SecondAlternativeName.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.QuestionsFilter === "Answered")
        {
            view = view.filter(a => a.Value != null);
        }
        else if (this.QuestionsFilter === "Not answered")
        {
            view = view.filter(a => a.Value == null);
        }
        else if (this.QuestionsFilter === "Commented")
        {
            view = view.filter(a => !isNullOrWhitespace(a.Comment));
        }
        else if (this.QuestionsFilter === "Not commented")
        {
            view = view.filter(a => isNullOrWhitespace(a.Comment));
        }

        return view;
    }
    get AnsweredQuestionsCount(): number { return this.rm.Questions.filter(a => a.Value != null).length; }
    get NotAnsweredQuestionsCount(): number { return this.questionsCount - this.AnsweredQuestionsCount; }
    get CommentedQuestionsCount(): number { return this.rm.Questions.filter(a => !isNullOrWhitespace(a.Comment)).length; }
    get NotCommentedQuestionsCount(): number { return this.questionsCount - this.CommentedQuestionsCount; }

    //@Watch('IsSaved')
    onIsSavedChanged(val: boolean, oldVal: boolean) 
    {
        if (val === false)
        {
            if (this.AutoSaveHandle == null)
            {
                this.AutoSaveHandle = setInterval(() =>
                {
                    if (this.IsSaved === false)
                    {
                        this.handleSavePanelistVotesCommand();
                    }

                }, 10000);
            }
        }
        else
        {
            if (this.AutoSaveHandle != null)
            {
                clearInterval(this.AutoSaveHandle);
                this.AutoSaveHandle = null;
            }
        }
    }

    ShowAlternativeDetailsCommand(name: string, descritpion: string)
    {
        this.alternativeDetailsDialog.show(name, descritpion);
    }

    ShowCriterionDetailsCommand(q: PanelistSurveyQuestionReadModel)
    {
        this.criterionDetailsDialog.show(q.CriterionName, q.CriterionPath, q.CriterionDescription);
    }

    scrollTop()
    {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    updateValue(q: PanelistSurveyQuestionReadModel, value: number | null)
    {
        if (q.Value !== value)
        {
            q.Value = value;
            this.IsSaved = false;
        }
    }

    updateComment(q: PanelistSurveyQuestionReadModel, comment: string)
    {
        if (q.Comment !== comment)
        {
            q.Comment = comment;
            this.IsSaved = false;
        }
    }


    handleSavePanelistVotesCommand()
    {
        this.IsSaved = null;

        const votes = this.rm.Questions.map(q =>
        {
            return {
                QuestionId: q.Id,
                Value: q.Value,
                Comment: q.Comment
            }
        });

        this.invokeSavePanelistVotesCommandV1(this.workspaceId, this.rm.EvalModelId, this.surveyId, this.projectUserId, votes, this.alternativeId);
    }

    mounted()
    {
        this.runPanelistSurveyAlternativePageQueryV1(this.workspaceId, this.surveyId, this.projectUserId, this.alternativeId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistSurveyAlternativePageReadModel")
        {
            this.rm = model as PanelistSurveyAlternativePageReadModel;
            this.initialized = true;
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (SavePanelistVotesCommandV1.matchType(cmd))
        {
            if (this.alternativeId === correlationId)
            {
                if (this.IsSaved == null)
                {
                    this.IsSaved = true;
                }
            }
        }
    }

    EnsureSavedOnExit(event: BeforeUnloadEvent)
    {
        if (this.IsSaved === true)
        {
            return;
        }

        this.handleSavePanelistVotesCommand();
        event.preventDefault();
        event.returnValue = "";
    }

    beforeMount()
    {
        window.addEventListener("beforeunload", this.EnsureSavedOnExit);
    }

    beforeRouteLeave(to: any, from: any, next: (arg?: any) => void)
    {
        if (this.IsSaved === false)
        {
            this.handleSavePanelistVotesCommand();
        }

        next();
    }

    beforeRouteUpdate(to: any, from: any, next: (arg?: any) => void)
    {
        if (this.IsSaved === false)
        {
            this.handleSavePanelistVotesCommand();
        }

        next();
    }


    beforeUnmount()
    {
        window.removeEventListener("beforeunload", this.EnsureSavedOnExit);

        if (this.AutoSaveHandle != null)
        {
            clearInterval(this.AutoSaveHandle);
            this.AutoSaveHandle = null;
        }
    }
}